import { createElement, memo, useRef, useCallback } from '@max/max';
import Image from '@hfe/max-image';
/**
 * GIF 动效组件：图片加载完成后开始计时，到达 duration 后触发 onEnd 回调
 */
const GifAnimView = memo(({ gifUrl, duration, onEnd }) => {
    const timerRef = useRef(null);
    const handleLoad = useCallback(() => {
        timerRef.current = setTimeout(() => {
            onEnd();
        }, duration);
    }, [duration, onEnd]);
    return <Image source={{
        uri: gifUrl
    }} style={{
        position: 'absolute',
        top: '-70rpx',
        left: 0,
        pointerEvents: 'none',
        zIndex: 100,
        width: '750rpx',
        height: '443rpx'
    }} resizeMode="contain" onLoad={handleLoad}/>;
});
export default GifAnimView;
